import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_InvoiceChronoSetting = _resolveComponent("InvoiceChronoSetting")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_InvoiceMailSetting = _resolveComponent("InvoiceMailSetting")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, { "no-gutters": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_expansion_panels, { class: "w-100" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_expansion_panel, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_expansion_panel_title, { class: "w-100" }, {
                      default: _withCtx(({ expanded }) => [
                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "10" }, {
                              default: _withCtx(() => _cache[1] || (_cache[1] = [
                                _createTextVNode(" Gestion des chronos ")
                              ])),
                              _: 1
                            }),
                            expanded
                              ? (_openBlock(), _createBlock(_component_v_col, {
                                  key: 0,
                                  cols: "2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                      activator: _withCtx(({ props }) => [
                                        _createVNode(_component_v_icon, _mergeProps({ color: "secondary" }, props, { class: "pr-4 w-100 h-100" }), {
                                          default: _withCtx(() => _cache[2] || (_cache[2] = [
                                            _createTextVNode("$oss-help")
                                          ])),
                                          _: 2
                                        }, 1040)
                                      ]),
                                      default: _withCtx(() => [
                                        _cache[3] || (_cache[3] = _createElementVNode("span", null, [
                                          _createElementVNode("strong", null, " Formatage du chrono de facturation "),
                                          _createElementVNode("br")
                                        ], -1)),
                                        _cache[4] || (_cache[4] = _createElementVNode("span", null, [
                                          _createTextVNode(" Ce qui doit être présent obligatoirement: "),
                                          _createElementVNode("br")
                                        ], -1)),
                                        _cache[5] || (_cache[5] = _createElementVNode("span", null, [
                                          _createTextVNode("- Le compteur de factures = \"X\""),
                                          _createElementVNode("br"),
                                          _createElementVNode("br")
                                        ], -1)),
                                        _cache[6] || (_cache[6] = _createElementVNode("span", null, [
                                          _createTextVNode("Ce que vous pouvez saisir:"),
                                          _createElementVNode("br")
                                        ], -1)),
                                        _cache[7] || (_cache[7] = _createElementVNode("span", null, [
                                          _createTextVNode("- Année au format long = \"YYYY\""),
                                          _createElementVNode("br")
                                        ], -1)),
                                        _cache[8] || (_cache[8] = _createElementVNode("span", null, [
                                          _createTextVNode("- Année au format court = \"YY\""),
                                          _createElementVNode("br")
                                        ], -1)),
                                        _cache[9] || (_cache[9] = _createElementVNode("span", null, [
                                          _createTextVNode("- Mois = \"MM\" pour afficher le mois"),
                                          _createElementVNode("br")
                                        ], -1)),
                                        _cache[10] || (_cache[10] = _createElementVNode("span", null, [
                                          _createTextVNode("- Jour = \"DD\" pour afficher le jour"),
                                          _createElementVNode("br")
                                        ], -1))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_expansion_panel_text, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_InvoiceChronoSetting, {
                          companyId: _ctx.companyId,
                          chrono: _ctx.advanceSetting.chrono
                        }, null, 8, ["companyId", "chrono"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_expansion_panel, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_expansion_panel_title, { "data-cy": "invoice-settings-email" }, {
                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createTextVNode(" Gestion des mails ")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_expansion_panel_text, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_InvoiceMailSetting, {
                          defaultMails: _ctx.advanceSetting.defaultMail,
                          onMailTemplateDelete: _ctx.onMailTemplateDeleted
                        }, null, 8, ["defaultMails", "onMailTemplateDelete"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, {
      "no-gutters": "",
      class: "pb-3 pt-2"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "9" }),
        _createVNode(_component_v_spacer),
        _createVNode(_component_v_col, {
          cols: "3",
          class: "d-flex justify-end"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              "data-cy": "invoice-settings-save",
              rounded: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateAdvanceSettings())),
              size: "small"
            }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [
                _createTextVNode("Enregister")
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}